import styled from 'styled-components'
import { MEDIA_WIDTHS } from '../../../themes'

export const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  max-width: 1096px;
  margin: 0 auto;
  display: grid;

  @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
    grid-template-columns: 200px 1fr;
  }

  grid-template-columns: 1fr 3fr;

`
export const Contents = styled.div`
  padding: 0 1rem 1rem;

  .ant-select-selector {
    &:hover {
      border-color: ${({ theme }) => theme.success} !important;
    }
  }

  .ant-select-focused {
    .ant-select-selector {
      border-color: ${({ theme }) => theme.success} !important;
    }
  }
`
